import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { ErrorObject } from '../ndm/models/error.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private toastr: ToastrService,
    private router: Router,
  ) { }

  showSuccess(message: any, title?: any) {
    this.toastr.success(message, title)
  }

  showError(message: any, title?: any) {
    this.toastr.error(message, title)
  }

  showInfo(message: any, title?: any) {
    this.toastr.info(message, title)
  }

  showWarning(message: any, title?: any) {
    this.toastr.warning(message, title)
  }

  showException(error: ErrorObject) {

    if (error) {
      let errorMessage = error.apierror?.message || "Error occured";
      error.apierror?.subErrors?.forEach(element => {
        errorMessage += "</br>" + element.message;
      });
      this.toastr.error(errorMessage, '', { enableHtml: true });
    } else {
      this.toastr.error("Error occured", "");
    }

    if (error.apierror.statusCode == '401') {
      sessionStorage.clear();
      this.router.navigate(['./login']);
    }
  }
}